webpackJsonp([73],{

/***/ 138:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 139:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(224)
}
var Component = __webpack_require__(153)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(324),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 151:
/***/ (function(module, exports) {

module.exports = {"1":"75PV 礼包","2":"250PV 礼包","3":"500V 礼包","4":"1000PV 礼包","1001027":"已存在","1002310":"上传失败","1002315":"文件不存在","1003001":"操作成功","1003006":"操作失败","1003007":"新增失败","1003008":"删除失败","1003009":"编辑失败","1003011":"系统异常","1003013":"session失效","1003015":"session异常","1003018":"无数据不允许导出","1003019":"操作失败，请刷新后重试！","1003021":"重复提交","1003671":"旧密码错误","1003672":"确认密码错误","1003673":"会员不存在","1003674":"不是注册账号绑定的邮箱","1003676":"链接无效","1003696":"当前会员已高于升级等级","1003697":"升级失败，月消费不足！","1003701":"产品已收藏","1003901":"无法上移","1003902":"无法下移","1003903":"数据异常，该个人网站无审核信息","1003904":"推荐产品数量已达上限","1003905":"用户暂无个人网站","1004156":"会员账户不存在","1004157":"金额错误","1004158":"账户余额不足","1004159":"转入账户不存在","1004160":"请勿给自己转账","1004161":"不在同一国家不能转账","1004162":"目标会员状态禁用不能转账","1004163":"不在同一安置网不能转账","1004164":"电子币提现金额为负,请重试","1004165":"提现金额不能小于最小提现金额","1004166":"提现金额不能大于最大提现金额","1004167":"红包金额为负，请重试","1004168":"红包状态不可用","1004169":"已过期!","1004170":"不能使用自己的红包","1004171":"不在同一国家，不能使用","1004172":"红包不存在","1004197":"转账失败","1004251":"默认地址无法删除","1004252":"注册地址无法删除","1004253":"收货地址不存在","1004254":"必须要有一个默认地址","1004805":"推荐人和安置人不在同一个安置网络下","1004806":"已有注册订单","1004807":"推荐人未购物","1004808":"安置人未购物","1004810":"会员ID格式不对","1004811":"推荐人格式不对","1004812":"安置人格式不对","1004813":"订单总PV小于会员注册级别","1004814":"推荐人不活跃","1004815":"安置人不活跃","1004816":"不在本系统","1004901":"订单不存在","1004902":"订单详情不存在","1004910":"产品{0}已经下架","1004911":"产品包{0}已经下架","1004918":"订单未全部发货，无法确认收货","1004919":"客服不能帮会员支付待付款订单","1009001":"产品下架","1009002":"库存数据异常","1009003":"库存不足","1009004":"产品数量和产品包产品数量不相等","1009005":"购物车已经清空","1009006":"未配置省份信息","1009007":"订单已支付","1009008":"已经支付过网络管理费","1009010":"该订单已生成","1009011":"电子币金额为零","1009012":"获取支付URL失败","1009013":"协议未配置","1009014":"已经是最新版本","2000001":"安置网异常","2000002":"安置人不在推荐人的安置网络中","2000003":"会员不在当前分公司","2000004":"请选择期数","2000005":"奖金已结算，不能修改上线","2000006":"推荐人不存在","2000007":"推荐人不能是暂存会员","2000008":"安置人不存在","2000009":"安置人不能是暂存会员","2000010":"推荐人不是有效会员","2000011":"安置人不是有效会员","2000012":"该推荐人为顾客","2000013":"输入的推荐人编码不合法","2000014":"输入的安置人编码不合法","2000015":"正常会员不能修改到暂存会员的网络","2000016":"输入的会员号不合法","2000017":"当前店铺没有分配号段","2000018":"号段已被使用","2000019":"号段不存在","2000020":"请输入当前分公司店铺编码","2000021":"分公司号段不存在","2000022":"未使用","2000023":"已使用","2000025":"区域号段管理","2000026":"分公司号段管理","2000027":"开始段号","2000028":"结束段号","2000029":"新增段号","2000031":"请输入号段","2000032":"请输入正确的号段范围","2000033":"号段已被使用，无法修改!","2000034":"旧号段范围","2000035":"删除段号","2000037":"删除起始段号","2000038":"删除末尾段号","2000039":"无可用号段","2000040":"号段统计","2000041":"号段","2000043":"请输入非0开头的八位数字","8001001":"请输入","8001002":"保存","8001003":"关闭","8001004":"请选择","8001005":"","8001006":"搜索","8001007":"序号","8001008":"导出Excel","8001009":"操作","8001010":"详情","8001011":"剩余","8001012":"天","8001013":"小时","8001014":"分","8001015":"删除","8001016":"提示","8001017":"确定","8001018":"取消","8001019":"取消中...","8001020":"返回","8001021":"重置","8001022":"显示","8001023":"隐藏","8001024":"提交","8001025":"系统错误！","8001026":"404 页面无法访问","8001027":"默认","8001028":"编辑","8001029":"绿世界商城","8001030":"警告","8001031":"合计","8001032":"去配置","8001033":"新增成功","8001034":"新增","8001035":"全部","8001036":"选择过滤条件","8001037":"完成","8001038":"无","8002001":"欢迎访问绿世界官网 | Jeming Enterprise Inc.","8002002":"登录","8002003":"注册","8002004":"我的收藏","8002005":"个人中心","8002006":"退出","8002007":"我的订单","8002008":"购物车","8002009":"全部分类","8002010":"全部产品","8002011":"热卖","8002012":"新品","8002013":"首页","8002014":"推荐","8002015":"关于我的","8002016":"更多","8002017":"产品包套组","8002018":"产品分类","8002019":"产品包","8002020":"订单管理","8002021":"收藏夹","8002022":"电子币","8002023":"我的账户","8002024":"财务记录","8002025":"电子币转账","8002026":"电子币提现","8002027":"提现记录","8002028":"红包管理","8002029":"奖金","8002030":"奖金查询","8002031":"注册","8002032":"代客注册","8002033":"会员列表","8002034":"我的顾客","8002035":"顾客列表","8002036":"订单列表","8002037":"网络查询","8002038":"表格网络","8002039":"树形网络","8002040":"组织网络","8002041":"个人网站","8002042":"网站配置","8002043":"设置","8002044":"个人信息","8002045":"邮寄地址","8002046":"安全设置","8002047":"会员升级","8002048":"协议","8002049":"注册协议","8002050":"隐私协议","8002051":"购买协议","8002052":"网络","8002053":"订单列表","8002054":"订单详情","8002055":"收藏列表","8002056":"奖金详情","8002057":"顾客详情","8002058":"顾客订单列表","8002059":"订单确认","8002060":"下单失败","8002061":"取消支付","8002062":"支付失败","8002063":"下单成功","8002064":"账户安全","8002065":"修改密码","8002066":"邮箱验证","8002067":"个人网站设置","8002068":"添加推荐产品","8002069":"购物","8002070":"购买协议","8002071":"隐私协议","8002072":"注册协议","8002073":"搜索结果","8002074":"消息列表","8002075":"直推线","8002076":"我的服务","8002077":"产品搜索","8002078":"注册购物","8002079":"新增地址","8002080":"编辑地址","8002081":"帮助","8002082":"常见问题","8002083":"添加产品","8002084":"权限配置","8002085":"密码修改","8002086":"语言","8002087":"版本号","8002088":"国家选择","8002089":"安全策略","8003001":"登录","8003002":"会员编号","8003003":"密码","8003004":"新用户注册","8003005":"忘记密码","8003006":"找回密码","8003007":"邮箱","8003008":"发送","8003009":"邮箱格式错误","8003010":"已发送验证请求，请登录邮箱进入修改密码","8003011":"设置密码","8003012":"密码","8003013":"确认密码","8003014":"密码不一致!","8003015":"密码设置成功，即将跳转登录!","8003016":"注册订单确认","8003017":"注册订单产品列表","8003018":"隐私协议","8003019":"购买协议","8003020":"注册协议","8003021":"会员","8003022":"顾客","8003023":"您好","8003024":"邮箱验证超链接无效","8003025":"重新找回密码","8003026":"您确认退出商城系统吗?","8003027":"会员账号","8003028":"验证码","8003029":"验证","8003030":"登录或注册","8003031":"切换账号","8003032":"您是否切换账号重新登录？","8004001":"邮寄方式","8004002":"快递","8004003":"自提","8004004":"产品信息","8004005":"产品详细信息","8004006":"单价","8004007":"数量","8004008":"PV","8004009":"金额","8004010":"固定产品包","8004011":"非固定产品包","8004012":"赠品","8004013":"产品总额","8004014":"产品折扣金额","8004015":"产品折扣PV","8004016":"订单折扣金额","8004017":"订单折扣PV","8004018":"运费","8004019":"总税费","8004020":"网络管理费","8004021":"订单手续费","8004022":"总PV","8004023":"总金额","8004024":"支付方式","8004025":"电子币支付","8004026":"电子币可用余额","8004027":"Papal支付","8004028":"组合支付（电子币+Papal）","8004029":"输入金额","8004030":"备注信息","8004031":"留言","8004032":"下单并支付","8004033":"请选择或添加邮寄地址","8004034":"请选择支付方式","8004035":"请输入电子币支付金额","8004036":"组合支付电子币金额不能等于订单总金额","8004037":"下单失败","8004038":"缺货","8004039":"库存不足","8004040":"订单已取消支付","8004041":"支付失败","8004042":"您已注册成为新会员 ","8004043":"会员编号","8004044":"请输入会员编号","8004045":"会员姓名","8004046":"请输入会员姓名","8004047":"国家","8004048":"加入时间","8004049":"开始时间","8004050":"结束时间","8004051":"邮箱","8004052":"推荐人","8004053":"推荐人姓名","8004054":"安置人","8004055":"安置人姓名","8004056":"加入时间","8004057":"状态","8004058":"购物","8004059":"欢迎来到绿世界!","8004060":"您注册成为绿世界会员，并拥有自己的商铺！或者，您可以注册成为一个绿世界的客户，为你提供许多优秀的产品。","8004061":"会员","8004062":"顾客","8004063":"网络信息","8004064":"推荐人Id","8004065":"安置人Id","8004066":"注册礼包","8004067":"会员信息","8004068":"姓","8004069":"中间名","8004070":"名","8004071":"性别","8004072":"男","8004073":"女","8004074":"公司名称","8004075":"出生日期","8004076":"社会保险号","8004077":"密码","8004078":"确认密码","8004079":"请输入确认密码","8004080":"电话","8004081":"手机","8004082":"邮寄地址","8004083":"省份","8004084":"城市","8004085":"邮政编码","8004086":"详情地址","8004087":"《注册协议》","8004088":"我已经阅读","8004089":"注册","8004090":"两次输入密码不一致!","8004091":"邮箱格式错误","8004092":"请阅读并勾选注册协议","8004093":"注册成功","8004094":"请确认信息数据是否完整","8004095":"最小购买不小于{0}PV产品","8004096":"购买注册单","8004097":"产品名称","8004098":"产品编码","8004099":"产品预览","8004100":"价格","8004101":"数量","8004102":"购买","8004103":"总金额","8004104":"总PV","8004105":"下单","8004106":"您还没有添加注册产品","8004107":"您还没有添加产品，请先添加产品！","8004108":"请购买不小于{0}PV产品","8004109":"正在代客注册","8004110":"正在代客购物","8004111":"正在代客下单","8004112":"新会员编号为 ","8004113":"如果新成员来自其他国家，请从右上角的国家列表中选择国家。新成员只能从其所属国家购买产品。","8004114":"请输入邮箱地址","8004115":"验证码发送成功！","8004116":"请输入会员账号","8004117":"请输入验证码","8004118":"会员注册","8004119":"语言切换","8004120":"注册类型","8004121":"请选择国家","8004122":"注冊协议","8004123":"请输入推荐人","8004124":"请输入安置人","8004125":"请选择注册礼包","8004126":"请输入名","8004127":"请输入姓","8004128":"请输入社会保障号","8004129":"请输入密码","8004130":"请输入电话","8004131":"请输入手机","8004132":"请选择省份","8004133":"请选择城市","8004134":"请输入收货地址","8004135":"请输入邮编","8004136":"请先勾选同意会员协议","8004137":"重置密码","8004138":"请输入密码（6~20位，包含字母）","8004139":"密码输入不一致","8004140":"密码重置成功","8004141":"您确认删除该商品吗","8004142":"您还未购物，暂时无法使用分享功能","8004143":"操作金额","8004144":"账户类型","8004145":"请选择或添加地址","8004146":"实付款","8004147":"下个级别需要购买{0}PV","8004148":"街道门牌号 楼层房间号信息","8004149":"请输入详细地址","8004150":"搜索条件","8004151":"请输入金额","8004152":"请输入旧密码","8004153":"获取验证码","8004154":"X秒后重试","8004155":"重新获取","8004156":"请选择您所在的州","8004157":"下一步","8004158":"个人用户","8004159":"企业用户","8004160":"请勾选全部条款","8004161":"持卡人姓名","8004162":"卡号","8004163":"过期时间(月/年）","8004164":"支付地址","8004165":"购物人签名","8004166":"请先签名","8004167":"条款与政策","8004168":"","8004169":"","8005001":"综合排序","8005002":"价格:从低到高","8005003":"价格:从高到低","8005004":"价格","8005005":"筛选","8005006":"组合产品","8005007":"库存不足!","8005008":"加入购物车","8005009":"取消收藏","8005010":"收藏","8005012":"产品包描述","8005013":"产品包关联产品","8005014":"请为套件选择以下产品","8005015":"仅{0}项","8005016":"已选择","8005017":"数量","8005018":"产品库存不足","8005019":"缺货","8005020":"请选择产品！","8005021":"选择产品总数与非固定产品包数量不一致，请重新选择！","8005022":"添加成功","8005023":"收藏成功","8005024":"取消收藏","8005025":"超出非固定产品包数量限制，请重新选择！","8005026":"促销","8005027":"活动时间","8005028":"产品描述","8005029":"此产品关联以下产品包套组","8005030":"去购买","8005031":"推荐产品","8005032":"特价产品","8005033":"超低价好货","8005034":"活动进行中","8005035":"活动已结束","8005036":"搜索您要找的商品","8005037":"名称:A到Z","8005038":"名称:Z到A","8005039":"排序","8005040":"买单一的商品","8005041":"选择任何{0}套来完成一套","8005042":"零售价格","8005043":"会员价格","8005044":"促销价格","8005045":"已下架","8005046":"赠品列表","8005047":"配置非固定产品包","8005048":"选择产品","8005049":"添加失败","8005050":"产品二维码","8005051":"请输入搜索内容","8005052":"搜索历史","8005053":"选择日期","8006001":"购物车","8006002":"商品总价","8006003":"订单结算","8006004":"购物车还是空，快去购物吧！","8006005":"您确认从购物车删除该产品吗？","8006006":"删除中...","8006007":"订单确认","8006008":"小计金额","8006009":"返回购物车","8006010":"电子币可用余额不足，请充值！","8006011":"组合支付电子币金额需大于0","8006012":"继续购物","8006013":"请先登录商城或注册账号成为会员再添加购物车","8006014":"恭喜您，支付成功！","8006015":"您的订单号","8006016":"单击此处打印发票","8006017":"代客下单成功！","8006018":"购物车还是空的，赶紧去逛逛吧！","8006019":"立即购物","8006020":"请登录添加您喜欢的商品","8007001":"电子币余额","8007002":"收款人编号","8007003":"转账金额","8007004":"手续费","8007005":"转账","8007006":"转账金额必须大于0","8007007":"转账成功","8007008":"提现金额","8007009":"用户名","8007010":"省份","8007011":"城市","8007012":"邮政编码","8007013":"详情地址","8007014":"备注说明","8007015":"提现","8007016":"请输入{0}~{1}提现金额","8007017":"提现金额大于账号可用余额","8007018":"正确邮箱格式错误","8007019":"提现成功","8007020":"操作时间","8007021":"操作人类型","8007022":"金额","8007023":"提现状态","8007024":"提现备注","8007025":"审核备注","8007026":"红包发放","8007027":"交易类型","8007028":"开始日期","8007029":"结束日期","8007030":"交易日期","8007031":"兑换成功","8007032":"发放成功","8007033":"备注","8007034":"电子币","8007035":"可用电子币","8007036":"冻结电子币","8007037":"红包发放","8007038":"红包金额","8007039":"邮箱","8007040":"有效截止日期","8007041":"红包发放记录","8007042":"已过期","8007043":"未兑换","8007044":"已兑换","8007045":"状态","8007046":"发放日期","8007047":"红包兑换","8007048":"兑换码","8007049":"红包有效期","8007050":"余额低于最低提款金额","8007051":"交易记录","8007052":"余额","8007053":"财务类型","8007054":"操作人","8007055":"电子币转账详情","8007056":"转账类型","8007057":"转出账户","8007058":"转入账户","8007059":"实际金额","8007060":"转入","8007061":"转出","8007062":"提现方式","8007063":"安全问题","8007064":"安全答案","8007065":"提现金额大于0","8007066":"电子币提现详情","8007067":"申请时间","8007068":"审核时间","8007069":"可发放金额","8007070":"发放方式","8007071":"您还未绑定银行卡信息?","8007072":"温馨提示","8007073":"去绑定","8007074":"暂不绑定","8007075":"去查看","8007076":"您还未绑定发票信息?","8007077":"您绑定的发票信息正在审核中，请耐心等待！","8007078":"您绑定的发票信息未通过审核，","8007079":"请输入兑换码","8008001":"奖金期数","8008002":"会员编号","8008003":"推荐奖","8008004":"快速启动奖","8008005":"矩阵奖","8008006":"领导奖","8008007":"个人销售奖","8008008":"总奖金","8008009":"奖金类型","8008010":"奖金明细","8008011":"会员姓名","8008012":"小车促销奖","8008013":"奖金金额","8008014":"期数","8008015":"月消费PV","8008016":"旅行点","8008017":"季度促销","8008018":"网络PV","8008019":"新会员PV","8008020":"推荐会员PV","8009001":"顾客信息","8009002":"顾客编号","8009003":"会员姓名","8009004":"加入时间","8009005":"国家","8009006":"电话","8009007":"电子邮件","8009008":"地址","8009009":"历史订单","8009010":"订单号","8009011":"订单日期","8009012":"金额","8009013":"总计金额","8009014":"总PV","8009015":"小计","8009016":"顾客姓名","8009017":"开始时间","8009018":"结束时间","8009019":"下单时间","8009020":"姓名","8010001":"网络类型","8010002":"推荐网","8010003":"安置网","8010004":"代数","8010005":"会员编码","8010006":"显示方式","8010007":"垂直显示","8010008":"水平显示","8010009":"会员详情","8010010":"会员姓名","8010011":"性别","8010012":"男","8010013":"女","8010014":"国家","8010015":"级别","8010016":"加入日期","8010017":"推荐人","8010018":"推荐人编号","8010019":"安置人","8010020":"安置人编号","8010021":"注册","8010022":"姓名","8010023":"当前级别","8010024":"最高级别","8010025":"最后一次购物时间","8010026":"请输入会员编码或会员名","8010027":"会员网络方视图","8010028":"会员网络家谱","8010029":"会员网络树状图","8010030":"当月PV","8010031":"序号","8010032":"Gen","8011001":"订单编号","8011002":"取消订单","8011003":"立即付款","8011004":"未付款","8011005":"待发货","8011006":"部分发货","8011007":"全部发货","8011008":"确认收货","8011009":"自动收货","8011010":"产品信息","8011011":"固定产品包","8011012":"非固定产品包","8011013":"赠品","8011014":"订单信息","8011015":"下单类型","8011016":"下单时间","8011017":"支付时间","8011018":"下单备注","8011019":"确认收货时间","8011020":"邮寄方式","8011021":"快递","8011022":"自提","8011023":"物流详情","8011024":"发货列表","8011025":"发货时间","8011026":"物流公司","8011027":"物流单号","8011028":"产品名称","8011029":"规格","8011030":"数量","8011031":"收货信息","8011032":"收件人","8011033":"联系电话","8011034":"收货地址","8011035":"支付方式","8011036":"支付金额","8011037":"商品金额","8011038":"商品折扣金额","8011039":"商品折扣PV","8011040":"订单折扣金额","8011041":"订单折扣PV","8011042":"运费","8011043":"总税费","8011044":"网络管理费","8011045":"服务费","8011046":"订单PV","8011047":"订单金额","8011048":"收货成功","8011049":"全部订单","8011050":"待收货","8011051":"请输入订单号搜索查询","8011052":"金额","8011053":"订单详情","8011054":"产品详细信息","8011055":"单价","8011056":"PV","8011057":"操作","8011058":"添加购物车","8011059":"清空列表","8011060":"您确认取消收藏吗？","8011061":"您确认取消全部收藏吗？","8011062":"送货方式","8011063":"打印","8011064":"发票","8011065":"订单号","8011066":"公司信息","8011067":"绿世界(加拿大)国际有限公司","8011068":"100 Tempo Avenue, unit 300, Toronto, ON Canada M2H 2N8","8011069":"税务号码: 836200980 RT0001","8011070":"网址:www.greatgreenworldna.com","8011071":"416-696-9858 Toll free : 1-888-502-6218","8011072":"邮政编码","8011073":"产品详情","8011074":"编码","8011075":"数量","8011076":"单价","8011077":"单个pv值","8011078":"手续费","8011079":"网络服务费","8011080":"付款日期","8011081":"待处理","8011082":"部分自提","8011083":"部分邮寄","8011084":"已发货","8011085":"件","8011086":"费用信息","8011087":"已经发货于","8011088":"使用物流公司","8012001":"旧密码","8012002":"新密码","8012003":"确认密码","8012004":"密码不一致!","8012005":"密码修改成功","8012006":"网络信息","8012007":"国家","8012008":"会员编号","8012009":"会员类型","8012010":"会员","8012011":"顾客","8012012":"推荐人编号","8012013":"推荐人姓名","8012014":"安置人编号","8012015":"安置人姓名","8012016":"注册产品包","8012017":"礼包","8012018":"注册时间","8012019":"个人信息","8012020":"会员级别","8012021":"姓名","8012022":"性别","8012023":"女","8012024":"男","8012025":"公司名称","8012026":"证件号","8012027":"生日","8012028":"省份","8012029":"城市","8012030":"邮政编码","8012031":"地址","8012032":"联系方式","8012033":"电话","8012034":"手机号","8012035":"邮箱","8012036":"会员升级","8012037":"升级级别","8012038":"升级","8012039":"编辑保存","8012040":"邮箱格式错误","8012041":"请选择升级级别","8012042":"升级成功！","8012043":"编辑成功！","8012044":"安全管理","8012045":"请完成所有安全设置以保护您的帐户","8012046":"密码","8012047":"建议您定期更改密码以保护您的帐户安全。","8012048":"修改密码","8012049":"您可以使用电子邮件找回密码并在核实您的电子邮件后收到公司的信息。","8012050":"邮箱验证","8012051":"已验证","8012052":"请确认您下面的电子邮件地址是正确。请如果不正确，请更新。","8012053":"请点击“发送电子邮件”按钮验证您的电子邮件。您将在您的电子邮件帐户中收到一封电子邮件。请点击邮件中的链接完成邮件验证。","8012054":"发送邮件","8012055":"新邮箱","8012056":"请输入新邮箱地址","8012057":"发送成功","8012058":"注册级别","8012059":"使用新地址","8012060":"新增邮寄地址","8012061":"编辑邮寄地址","8012062":"您确认删除邮寄地址吗？","8012063":"未购物会员","8013001":"个人信息","8013002":"省份","8013003":"城市","8013004":"出生日期","8013005":"邮政编码","8013006":"详细住址","8013007":"手机号","8013008":"邮箱","8013009":"脸谱网","8013010":"推特","8013011":"产品名称","8013012":"产品编码","8013013":"图片","8013014":"价格","8013015":"已添加","8013016":"添加","8013017":"个人网站","8013018":"网站地址","8013019":"复制","8013020":"推荐产品","8013021":"添加推荐产品","8013022":"头像","8013023":"点击上传","8013024":"只能上传jpg/png文件，且不超过500kb","8013025":"姓名","8013026":"国家","8013027":"个人简介","8013028":"个人介绍需经分公司批准后方可生效！","8013029":"审核状态","8013030":"待审核","8013031":"驳回","8013032":"通过","8013033":"审核说明","8013034":"邮箱格式错误","8013035":"删除成功","8013036":"提交成功","8013037":"复制成功","8013038":"复制失败","8013039":"个人简介不能为空","8013040":"请修改个人简介内容！","8013041":"出生日期格式错误","8013042":"没有收货地址","8013043":"分公司","10080001":"推荐人不存在","10080002":"安置人不存在","10080003":"安置人名额已满","10080004":"两次密码不一致","10080005":"用户不存在","10080006":"会员密码不正确","10080007":"会员禁用","10080008":"会员挂起","10080009":"会员不活跃","20010001":"加拿大","20010002":"美国","20010003":"巴巴多斯","20010004":"多米尼加共和国","20010005":"牙买加","20010006":"圣基茨和尼维斯","20010007":"圣文森特和格林纳丁斯","20010008":"特立尼达和多巴哥","20010009":"圣卢西亚","20060001":"正常","20060002":"禁用","20060003":"激活未购物","20160001":"1*","20160002":"2*","20160003":"3*","20160004":"4*","20160005":"5*","20160006":"6*","20160007":"7*","20160008":"8*","20160009":"9*","20160010":"10*","20160011":"11*","20160012":"12*","20160013":"13*","20160014":"14*","20160015":"15*","20160016":"16*","20160017":"17*","20170001":"培育奖","20170002":"推荐奖","20170003":"管理奖","20170004":"合赢奖","20170005":"重复消费奖","20170006":"零售奖","20170007":"见点奖","20170008":"拓展奖","20170009":"直接奖","20170010":"间接奖","20170011":"领导奖","20170012":"事业伙伴奖","20170013":"荣衔直接奖","20170015":"荣衔间接奖","20170016":"钻石领导奖","20170017":"荣衔奖","20170018":"小车奖","20170019":"扣除","20170020":"差额","20170021":"升级时间","20170022":"直推人数","20170023":"当月个人业绩","20170024":"当月整网业绩","20170025":"网络基础业绩","20170026":"网络业绩","20170027":"小组业绩（含基础）","20170028":"小组业绩（不含基础）","20170029":"累计个人业绩","20170030":"累计整网业绩","20170031":"代数","20180001":"注册订单","20180002":"补注册订单","20180003":"预购订单","20180004":"普通订单","20180005":"顾客零售","20180006":"秒杀订单","20180007":"重复消费","20180008":"积分换购订单","20190001":"会员","20190002":"客服","20190003":"系统","20190004":"店铺","100369901":"会员不存在","100369902":"邮箱已验证","100369911":"验证码不存在","100369912":"验证码不匹配","100369913":"请先提交个人信息","320030001":"英文","320030002":"西文","320030003":"法文","320030004":"俄文","320030005":"中文","320030006":"巴基斯坦语","320070001":"注册订单","320070002":"会员零售","320070003":"顾客零售","320100001":"批准","320100002":"驳回","320100003":"未审核","320160001":"现金","320160002":"电子币","320160003":"银行卡","320160004":"pos机","320160005":"信用卡","320160006":"PayPal","320160007":"组合支付","320160008":"Email支付","320160009":"Checkout支付","320170001":"联邦税","320170002":"省税","320170003":"HST","320170004":"特区税","320170005":"州税","320170006":"县税","320170007":"城市税","320170008":"运输税","320190001":"满减","320190002":"满送","320190003":"买特价","320190004":"买送","320210001":"热卖","320210002":"新品","320210003":"产品包","320310001":"转账","320310002":"充值","320310003":"扣款","320310004":"提现","320310005":"提现驳回","320310006":"红包发放","320310007":"红包退还","320310008":"红包兑换","320310009":"购物消费","320310010":"购物取消","320310011":"奖金发放","320310012":"其他","320310013":"兑换","----------全局":"----------------（公用文字）","----------导航栏":"----------------","----------登录相关":"----------------","----------注册、购物相关":"----------------","----------商城产品相关":"----------------","----------购物车相关":"----------------","----------个人中心-账户管理":"----------------","----------个人中心-奖金管理":"----------------","----------个人中心-顾客管理":"----------------","----------个人中心-网络查询":"----------------","----------个人中心-订单管理":"----------------","----------个人中心-设置管理":"----------------","----------个人中心-个人网站":"----------------","----------数据库字典表":"----------------","---------会员职务------------":"","---------订单类别------------":"","----------接口错误码提示":"----------------","-----------------------------------------------":""}

/***/ }),

/***/ 152:
/***/ (function(module, exports) {

module.exports = {"1":"75PV","2":"250PV","3":"500PV","4":"1000PV","1001027":"Existed","1002310":"Upload Error!","1002315":"File does not exist","1003001":"Operation Success","1003006":"Operation Failure","1003007":"Add Failure","1003008":"Delete Failure","1003009":"Edit Error","1003011":"System Exception","1003013":"Session Failure","1003015":"Session Exception","1003018":"No data allowed to export","1003019":"The operation failed, please refresh and try again!","1003021":"Repeated Submit","1003671":"Old Password Error","1003672":"Confirm Password Error","1003673":"Member does not exist","1003674":"Not the mailbox bound to the registered account","1003676":"Invalid Link","1003696":"The current member is above the upgrade level","1003697":"Upgrade failed, insufficient monthConsume!","1003701":"Product has been favorited","1003901":"Cannot move up","1003902":"Cannot move down","1003903":"The data is abnormal, the personal website has no review information","1003904":"The number of recommended products has reached the upper limit","1003905":"User has no personal website","1004156":"Member account does not exist","1004157":"Wrong Amount","1004158":"Insufficient Account Balance","1004159":"The transfer account does not exist","1004160":"Do not transfer money to yourself","1004161":"Not in the same country","1004162":"The target member status is disabled and cannot be transferred","1004163":"Not in the same resettlement network and cannot be transferred","1004164":"The e-money withdrawal amount is negative, please try again","1004165":"The e-money withdrawal amount is negative, please try again","1004166":"The withdrawal amount cannot be greater than the maximum withdrawal amount","1004167":"The red packet amount is negative, please try again","1004168":"Red packet status is not available","1004169":"Expired!","1004170":"Can't redeem your own gift card","1004171":"Not in the same country and cannot be used","1004172":"Gift card code you enter is invalid","1004197":"Transfer failed","1004251":"Default address cannot be deleted","1004252":"Registered address cannot be deleted","1004253":"Delivery address does not exist","1004254":"Must have a default address","1004805":"The recommender and the placement person are not in the same placement network","1004806":"Already Registered Order","1004807":"Sponsor did not shop","1004808":"Placement did not shop","1004810":"Member ID format is incorrect","1004811":"Sponsor format is incorrect","1004812":"Placement format is incorrect","1004813":"The order total PV is less than the member registration level","1004814":"Referrer is not active","1004815":"Placement person is not active","1004816":"Not in the system","1004901":"Order does not exist","1004902":"Order details do not exist","1004910":"Product {0} has been removed","1004911":"Kit {0} has been removed","1004918":"The order is not fully shipped, and the receipt cannot be confirmed","1004919":"Customer service cannot help members pay for pending orders","1009001":"Product off the shelf","1009002":"Abnormal inventory data","1009003":"Inventory Shortage","1009004":"The product quantity and the product package quantity are not equal","1009005":"Shopping cart has been emptied","1009006":"Province information is not configured","1009007":"Order Paid","1009008":"Have already paid the NET Admin Fee","1009010":"The order has been generated","1009011":"The electronic currency amount is zero","1009012":"Failed to get payment URL","1009013":"Agreement Not Config","1009014":"Already the latest version","2000001":"Directline net error","2000002":"The placenment is not in sponsor's network","2000003":"Member not in current branch","2000004":"Please choose period","2000005":"Bonus settled, cannot modify up line","2000006":"The sponsor is not exist","2000007":"Sponsor cannot be temporary","2000008":"The directline is not exist","2000009":"Directline cannot be temporary","2000010":"Sponsor not valid","2000011":"Directline not valid","2000012":"The sponsor is a customer.","2000013":"The sponsor is not exist","2000014":"The directline is not exist","2000015":"You can not change to abnormal member","2000016":"Code has been used,cannot be modified!","2000017":"Please enter the correct range","2000018":"Code has been used","2000019":"Code does not exist","2000020":"Please enter the store code of the current branch","2000021":"Branch Code does not exist","2000022":"Unused","2000023":"Used","2000025":"Area Code Management","2000026":"Branch Code Management","2000027":"Start Code","2000028":"End Code","2000029":"Add Code","2000031":"Please enter code","2000032":"Please enter the correct range","2000033":"Code has been used,cannot be modified!","2000034":"Old segment range","2000035":"Delete Code","2000037":"Delete Start Code","2000038":"Delete End Code","2000039":"No available number range","2000040":"Code Statistics","2000041":"Code Range","2000043":"Please enter an eight digit number start without 0","8001001":"Please Enter","8001002":"Save","8001003":"Close","8001004":"Please Choose","8001005":"","8001006":"Search","8001007":"S/N","8001008":"Export To Excel","8001009":"Operation","8001010":"Details","8001011":"Surplus","8001012":"Day","8001013":"Hour","8001014":"Minute","8001015":"Delete","8001016":"Tips","8001017":"Confirm","8001018":"Cancel","8001019":"Canceling","8001020":"Back","8001021":"Reset","8001022":"Display","8001023":"Hide","8001024":"Submit","8001025":"System Error!","8001026":"404 page not accessible","8001027":"Default","8001028":"Edit","8001029":"Green World Mall","8001030":"Warning","8001031":"Total","8001032":"Config Product","8001033":"Added successfully","8001034":"Add","8001035":"All","8001036":"Select filter criteria","8001037":"Finished","8001038":"NO","8002001":"Welcome to Green World! | Jeming Enterprise Inc.","8002002":"Login","8002003":"Register","8002004":"Wish List","8002005":"My Account","8002006":"Logout","8002007":"Order","8002008":"Cart","8002009":"All Categories","8002010":"All Products","8002011":"Hot Sale","8002012":"New Product","8002013":"Home","8002014":"Recommend","8002015":"About Me","8002016":"More","8002017":"Promotion Kit","8002018":"Product Category","8002019":"Kit","8002020":"Order Management","8002021":"Wish List","8002022":"Electronic Currency","8002023":"My Account","8002024":"Transaction History","8002025":"Transfer","8002026":"Withdraw","8002027":"Withdraw History","8002028":"Gift Card","8002029":"Bonus","8002030":"Bonus","8002031":"Registration","8002032":"Registration","8002033":"Member List","8002034":"My Customer","8002035":"Customer List","8002036":"Order List","8002037":"Network Search","8002038":"Genealogy","8002039":"Tree View","8002040":"Square View","8002041":"Personal Website","8002042":"Personal Website Setting","8002043":"Profile","8002044":"Personal Info","8002045":"Mailing Address","8002046":"Security Settings","8002047":"Member Upgrade","8002048":"Agreement","8002049":"Distributor Agreement","8002050":"Privacy Policy","8002051":"Purchase Policy","8002052":"Network","8002053":"Order List","8002054":"Order Details","8002055":"Wish List","8002056":"Bonus Details","8002057":"Customer Details","8002058":"Customer Order List","8002059":"Order Confirmation","8002060":"Order Failed","8002061":"Cancel Payment","8002062":"Payment Failed","8002063":"Order Success","8002064":"Account Security","8002065":"Change Password","8002066":"E-mail Verification","8002067":"Personal Website Setting","8002068":"Add Recommended Products","8002069":"Shopping","8002070":"Shopping Agreement","8002071":"Privacy Agreement","8002072":"Registration Agreement","8002073":"Search Results","8002074":"Message List","8002075":"Direct Push Line","8002076":"My Service","8002077":"Product Search","8002078":"Register to shop","8002079":"Add Address","8002080":"Edit Address","8002081":"Help","8002082":"common problem","8002083":"Add Product","8002084":"Privilege Configuration","8002085":"Password Change","8002086":"Language","8002087":"Version Number","8002088":"Country Selection","8002089":"Security Policy","8003001":"Login","8003002":"Member ID","8003003":"Password","8003004":"Register","8003005":"Forgot Password","8003006":"Retrieve Password","8003007":"Email","8003008":"Send","8003009":"Email Format Error","8003010":"The verification request has been sent, please log in to the mailbox to enter to modify the password","8003011":"Set Password","8003012":"Password","8003013":"Confirm Password","8003014":"The passwords are inconsistent!","8003015":"The password is set successfully, you will be redirected to login!","8003016":"Registration Order Confirmation","8003017":"Register Order Product List","8003018":"Privacy Agreement","8003019":"Shopping Agreement","8003020":"Registration Agreement","8003021":"Member","8003022":"Customer","8003023":"Hello","8003024":"Email verification hyperlink is invalid","8003025":"Recover Password","8003026":"Are you sure to logout your account?","8003027":"Member Account","8003028":"Verification Code","8003029":"Verify","8003030":"Login or Register","8003031":"Switch account","8003032":"Are you switching accounts to log in again?","8004001":"Mailing Method","8004002":"Post","8004003":"Pick Up","8004004":"Product Information","8004005":"Product","8004006":"Price","8004007":"Quantity","8004008":"PV","8004009":"Amount","8004010":"Fixed Kit","8004011":"Non-fixed Kit","8004012":"Gift","8004013":"Total Amount","8004014":"Product Discount Amount","8004015":"Product Discount PV","8004016":"Order Discount Amount","8004017":"Order Discount PV","8004018":"Shipping","8004019":"Total Tax","8004020":"Annual Website Fee","8004021":"Order Fee","8004022":"Total PV","8004023":"Total Amount","8004024":"Payment Method","8004025":"Electronic Currency Payment","8004026":"Available Balance of Electronic Currency","8004027":"PayPal","8004028":"Multiple Payments(Electronic Currency + PayPal)","8004029":"Enter The Amount","8004030":"Message","8004031":"Remark","8004032":"Place Order","8004033":"Please select or add a mailing address","8004034":"Please select mode of payment","8004035":"Please enter the electronic currency payment amount","8004036":"The combined payment electronic currency amount cannot be equal to the total order amount","8004037":"Order Failed","8004038":"Out of Stock","8004039":"Inventory Shortage","8004040":"Order has been cancelled","8004041":"Payment Failed","8004042":"You have successfully registered new member ","8004043":"Member ID","8004044":"Please enter Member ID","8004045":"Member Name","8004046":"Please enter member name","8004047":"Country","8004048":"Join Date","8004049":"Start Date","8004050":"End Date","8004051":"Email","8004052":"Sponsor","8004053":"Sponsor Name","8004054":"Placement","8004055":"Placement Name","8004056":"Join Date","8004057":"Status","8004058":"Shopping","8004059":"Welcome to Green World!","8004060":"Register as Green World member, start your business! OR register as a Green World customer to get excellent products","8004061":"Member","8004062":"Customer","8004063":"Network Information","8004064":"Sponsor ID","8004065":"Placement ID","8004066":"Package","8004067":"Personal Information","8004068":"Last Name","8004069":"Middle Name","8004070":"First Name","8004071":"Gender","8004072":"Male","8004073":"Female","8004074":"Company Name","8004075":"Birthday","8004076":"Social Insurance Number","8004077":"Password","8004078":"Confirm Password","8004079":"Please enter confirm password","8004080":"Phone","8004081":"Mobile","8004082":"Address","8004083":"Province","8004084":"City","8004085":"Postal Code","8004086":"Address","8004087":" ” Registration Agreement “ ","8004088":"Read & agree ","8004089":"Submit","8004090":"The two passwords are not consistent!","8004091":"Email Format Error","8004092":"Please read and check the registration agreement","8004093":"Registration Success","8004094":"Please confirm whether the information data is complete","8004095":"The total PV of the products you purchase cannot be less than {0}PV","8004096":"Purchase Registration","8004097":"Product Name","8004098":"Product Code","8004099":"Product Preview","8004100":"Price","8004101":"Quantity","8004102":"Buy","8004103":"Total Amount","8004104":"Total PV","8004105":"Place Order","8004106":"You have not added a registered product","8004107":"You have not added a product, please add a product first!","8004108":"The PV of your order cannot be less than {0}","8004109":"Valet Registration","8004110":"Valet Shopping","8004111":"Valet Placing Order","8004112":"New member ID is ","8004113":"If new member is from other country， please select the country from the country list on right-top corner. New member can only purchase products from the country he/she belongs to.","8004114":"Please enter your email address","8004115":"The verification code was sent successfully!","8004116":"Please enter a member account","8004117":"Please enter the verification code","8004118":"Member Registration","8004119":"Language Switch","8004120":"Registration Type","8004121":"Please select a country","8004122":"Registration Agreement","8004123":"Please enter the recommender","8004124":"Please enter the placement person","8004125":"Please select the registration package","8004126":"Please enter first name","8004127":"Please enter the last name","8004128":"Please enter social security number","8004129":"Please enter the password","8004130":"Please enter the phone number","8004131":"Please enter your phone","8004132":"Please select a province","8004133":"Please select a city","8004134":"Please enter the delivery address","8004135":"Please enter the zip code","8004136":"Please tick to agree to the membership agreement","8004137":"Reset Password","8004138":"Please enter a password (6~20 digits, including letters)","8004139":"Password input is inconsistent","8004140":"Password reset successfully","8004141":"Are you sure you want to delete this product","8004142":"You have not made a purchase yet, and the sharing function is temporarily unavailable","8004143":"Operation amount","8004144":"Account type","8004145":"Please select or add an address","8004146":"Actual Payment","8004147":"The next level needs to purchase {0}PV","8004148":"Street house number, floor room number information","8004149":"Please enter the detailed address","8004150":"Search Criteria","8004151":"Please enter the amount","8004152":"Please enter the old password","8004153":"Get verification code","8004154":"Retry in X seconds","8004155":"Reacquire","8004156":"Please select your state","8004157":"Next","8004158":"Individual users","8004159":"Enterprise users","8004160":"Please check all terms","8004161":"Name on Card","8004162":"Card No.","8004163":"Exp.Date(month/year)","8004164":"Billing Adreess","8004165":"Buyer’s Signature","8004166":"Please sign first.","8004167":"Terms&Policies","8004168":"","8004169":"","8005001":"Best Match","8005002":"Price:Low To High","8005003":"Price:High To Low","8005004":"Price","8005005":"Filter","8005006":"Combination Products","8005007":"Inventory Shortage!","8005008":"Add to Cart","8005009":"Cancel Wish","8005010":"Add to Wish List","8005012":"Kit Description","8005013":"Kit Related Products","8005014":"Please select the following products for the product package","8005015":"Only {0} items","8005016":"Chosen","8005017":"Quantity","8005018":"Insufficient Product Inventory","8005019":"Out Of Stock","8005020":"Please select a product!","8005021":"The total number of selected products is inconsistent with the number of non-fixed product packages","8005022":"Added to Cart Successfully.","8005023":"Collection Success","8005024":"Unfavorite","8005025":"Exceeding the limit of the number of non-fixed product packages, please select again!","8005026":"Promotion","8005027":"Activity Time","8005028":"Product Description","8005029":"Get additional discount when you buy a Set of this products.","8005030":"Buy a Set","8005031":"Recommended Products","8005032":"Discounted Item","8005033":"Super Low Price Goods","8005034":"Activity In Progress","8005035":"Activity Is Over","8005036":"Search for the product you are looking for","8005037":"Name:A to Z","8005038":"Name:Z to A","8005039":"Sort by","8005040":"Buy Single product","8005041":"Pick any {0} items to complete one Set","8005042":"Retail Price","8005043":"Member Price","8005044":"Promotion Price","8005045":"Has been removed","8005046":"Bonus List","8005047":"Configure non-fixed product package","8005048":"Select Product","8005049":"Failed to add","8005050":"Product QR Code","8005051":"Input search content","8005052":"Search History","8005053":"Select Date","8006001":"Shopping Cart","8006002":"Subtotal","8006003":"Proceed to Checkout","8006004":"The shopping cart is still empty, go shopping!","8006005":"Are you sure to delete this product from the shopping cart?","8006006":"Deleting...","8006007":"Order Confirmation","8006008":"Subtotal Amount","8006009":"Return To Shopping Cart","8006010":"The available balance of electronic currency is insufficient, please recharge!","8006011":"The combined payment electronic currency amount must be greater than 0","8006012":"Continue Shopping","8006013":"Please log in to the mall or register an account to become a member before adding the shopping cart","8006014":"Thanks for your order！","8006015":"Your order number","8006016":"Click here to print invoice.","8006017":"Order successfully!","8006018":"The shopping cart is still empty, go shopping!","8006019":"Buy Now","8006020":"Please login to add your favorite products","8007001":"E-Currency Balance","8007002":"To","8007003":"Transfer Amount","8007004":"Fee","8007005":"Transfer","8007006":"The transfer amount must be greater than 0","8007007":"Transfer Success","8007008":"Withdrawal Amount","8007009":"Name","8007010":"Province","8007011":"City","8007012":"Postal Code","8007013":"Address","8007014":"Comments","8007015":"Withdraw","8007016":"Please enter {0}~{1} withdrawal amount","8007017":"The withdrawal amount is greater than the available balance of the account","8007018":"The correct email format is wrong","8007019":"Withdrawal Success","8007020":"Date and Time","8007021":"Operator","8007022":"Amount","8007023":"Status","8007024":"Comments","8007025":"Review Notes","8007026":"Red envelope issuance","8007027":"Transaction Type","8007028":"Start Date","8007029":"End Date","8007030":"Transaction Date","8007031":"Redemption Success","8007032":"Issued Success","8007033":"Comments","8007034":"Electronic Currency","8007035":"Available Electronic Currency","8007036":"Hold Electronic Currency","8007037":"Gift Card Issue","8007038":"Amount","8007039":"Email","8007040":"Expire Date","8007041":"Gift Card List","8007042":"Expired","8007043":"Issued","8007044":"Redeemed","8007045":"Status","8007046":"Issued Date","8007047":"Gift Card Redeem","8007048":"Gift Card Code","8007049":"Red Packet validity","8007050":"The balance amount is lower than the minimum withdrawal amount","8007051":"Transaction History","8007052":"Balance","8007053":"Financial Type","8007054":"Operator","8007055":"Electronic currency transfer details","8007056":"Transfer Type","8007057":"Transfer account","8007058":"Transfer into account","8007059":"Actual Amount","8007060":"Transfer in","8007061":"Transfer Out","8007062":"Withdrawal Method","8007063":"Security Issues","8007064":"Security Answer","8007065":"The withdrawal amount is greater than 0","8007066":"Electronic currency withdrawal details","8007067":"Application Time","8007068":"Audit Time","8007069":"Disbursable Amount","8007070":"Distribution Method","8007071":"You haven't bound bank card information yet?","8007072":"Warm Reminder","8007073":"Unbind","8007074":"Not to bind temporarily","8007075":"Go check","8007076":"You haven't bound the invoice information yet?","8007077":"Your bound invoice information is under review, please be patient!","8007078":"The invoice information you bound has not passed the review,","8007079":"Please enter the redemption code","8008001":"Bonus Periods","8008002":"Member ID","8008003":"Enroller","8008004":"FSB","8008005":"Matrix","8008006":"Matching","8008007":"PersonalSale","8008008":"Total Bonus","8008009":"Bonus Type","8008010":"Bonus Details","8008011":"Member Name","8008012":"Car Award Promotion","8008013":"Bonus Amount","8008014":"Periods","8008015":"Current Month PV","8008016":"Travel Point","8008017":"Quarterly Promotion","8008018":"Network PV","8008019":"New Member PV","8008020":"Sponsored member PV","8009001":"Customer Information","8009002":"Customer ID","8009003":"Member Name","8009004":"Join Date","8009005":"Country","8009006":"Phone","8009007":"Email","8009008":"Address","8009009":"Historical Orders","8009010":"Order No","8009011":"Order Date","8009012":"Amount","8009013":"Total Amount","8009014":"Total PV","8009015":"Subtotal","8009016":"Customer Name","8009017":"Start Date","8009018":"End Date","8009019":"Order Time","8009020":"Name","8010001":"Network Type","8010002":"Sponsor Network","8010003":"Placement Network","8010004":"Algebra","8010005":"Member ID","8010006":"Display Method","8010007":"Vertical Display","8010008":"Horizontal Display","8010009":"Member Details","8010010":"Member Name","8010011":"Gender","8010012":"Male","8010013":"Female","8010014":"Country","8010015":"Level","8010016":"Join Date","8010017":"Sponsor","8010018":"Sponsor ID","8010019":"Placement","8010020":"Placement ID","8010021":"Registered","8010022":"Name","8010023":"Current Rank","8010024":"Best Rank","8010025":"Last Shopping Time","8010026":"member code or member name","8010027":"Member Square View Network","8010028":"Member Genealogy Network","8010029":"Member Tree View Network","8010030":"Current PV","8010031":"No.","8010032":"Gen","8011001":"Order No","8011002":"Cancel Order","8011003":"Immediate Payment","8011004":"Unpaid","8011005":"To Be Delivered","8011006":"Partial Delivery","8011007":"Ship All","8011008":"Confirm Receipt","8011009":"Automatic Receipt","8011010":"Product Information","8011011":"Fixed Kit","8011012":"Non-fixed Kit","8011013":"Gift","8011014":"Order Information","8011015":"Order Type","8011016":"Order Time","8011017":"Payment Time","8011018":"Message","8011019":"Confirm Receipt Time","8011020":"Shipping Information","8011021":"Mail","8011022":"Picked Up","8011023":"Logistics Details","8011024":"Shipping List","8011025":"Delivery Time","8011026":"Logistics Company","8011027":"Tracking Number","8011028":"Product Name","8011029":"Spec","8011030":"Quantity","8011031":"Delivery Information","8011032":"Recipient","8011033":"Contact Number","8011034":"Shipping Address","8011035":"Payment Method","8011036":"Payment Amount","8011037":"Product Amount","8011038":"Product Discount Amount","8011039":"Product discount PV","8011040":"Order Discount Amount","8011041":"Order Discount PV","8011042":"Shipping Fee","8011043":"Total Tax","8011044":"Annual Website Fee","8011045":"Service Fee","8011046":"Order PV","8011047":"Sub Total","8011048":"Received Success","8011049":"All Orders","8011050":"To Be Received","8011051":"Please enter the order number search query","8011052":"Total","8011053":"Order Details","8011054":"Product","8011055":"Price","8011056":"PV","8011057":"Operation","8011058":"Add To Cart","8011059":"Clear","8011060":"Are you sure to remove this product from Wish List?","8011061":"Are you sure to cancel all collections?","8011062":"Shipping Method","8011063":"Print","8011064":"Invoice","8011065":"Order No","8011066":"Company Information","8011067":"Great Green World WO DE Canada International Inc","8011068":"100 Tempo Avenue, unit 300, Toronto, ON Canada M2H 2N8","8011069":"Tax number: 836200980 RT0001","8011070":"Website:www.greatgreenworldna.com","8011071":"416-696-9858 Toll free : 1-888-502-6218","8011072":"ZIP Code","8011073":"Product Detail","8011074":"Code","8011075":"Qty","8011076":"Price/Each","8011077":"PV/Each","8011078":"Handling Fee","8011079":"Website Service Fee","8011080":"Payment Date","8011081":"Processing","8011082":"Partial Picked up","8011083":"Partial Mail","8011084":"Shipped","8011085":"Pieces","8011086":"Cost Information","8011087":"Shipped on","8011088":"by","8012001":"Old Password","8012002":"New Password","8012003":"Confirm Password","8012004":"The password is inconsistent!","8012005":"Password Reset Complete","8012006":"Network Information","8012007":"Country","8012008":"Member ID","8012009":"Member Type","8012010":"Member","8012011":"Customer","8012012":"Sponsor ID","8012013":"Sponsor Name","8012014":"Placement ID","8012015":"Placement Name","8012016":"Register Package","8012017":"Gift Pack","8012018":"Joined Date","8012019":"Personal Information","8012020":"Membership Level","8012021":"Name","8012022":"Gender","8012023":"Female","8012024":"Male","8012025":"Company Name","8012026":"Identity No","8012027":"Birthday","8012028":"Province","8012029":"City","8012030":"Postal Code","8012031":"Address","8012032":"Contact Information","8012033":"Phone","8012034":"Mobile","8012035":"Email","8012036":"Member Upgrade","8012037":"Upgrade Level","8012038":"Upgrade","8012039":"Edit And Save","8012040":"Email Format Error","8012041":"Please select an upgrade level","8012042":"Update Success!","8012043":"Edit Success!","8012044":"Safety Management","8012045":"Please complete all security settings to protect your account","8012046":"Password","8012047":"It is recommended that you change your password regularly to protect your account security.","8012048":"Change Password","8012049":"You can use email to retrieve your password and receive company information after verifying your email","8012050":"E-mail Verification","8012051":"Verified","8012052":"Please confirm that your email address below is correct. Please update if it is incorrect.","8012053":"Please click the 'Send Email' button to verify your email. You will receive an email in your email account. Please click the link in the email to complete the email verification.","8012054":"Send Email","8012055":"New Email","8012056":"Please enter a new email address","8012057":"Sent Success","8012058":"Join Level","8012059":"Use New Address","8012060":"Add Mailing Address","8012061":"Edit Mailing Address","8012062":"Are you sure to delete the mailing address?","8012063":"No purchase","8013001":"Personal Information","8013002":"Province","8013003":"City","8013004":"Birthday","8013005":"Postal Code","8013006":"Address","8013007":"Mobile","8013008":"Email","8013009":"Facebook","8013010":"Twitter","8013011":"Product Name","8013012":"Product Code","8013013":"Image","8013014":"Price","8013015":"Added","8013016":"Add","8013017":"Personal Website","8013018":"Website Address","8013019":"Copy","8013020":"Recommended Products","8013021":"Add Recommended Products","8013022":"Avatar","8013023":"Click Upload","8013024":"Only jpg/png files can be uploaded, and no more than 500kb","8013025":"Name","8013026":"Country","8013027":"Personal Profile","8013028":"The personal introduction can only be effective after the approval of the branch company!","8013029":"Approval Status","8013030":"Pending","8013031":"Reject","8013032":"Pass","8013033":"Review Instructions","8013034":"Email Format Error","8013035":"Delete Success","8013036":"Submitted Success","8013037":"Copy Success","8013038":"Copy Failed","8013039":"Personal profile cannot be empty","8013040":"Please modify the content of your profile!","8013041":"Birth date format is wrong","8013042":"No delivery address","8013043":"Branch","10080001":"Sponsor does not exist","10080002":"Placement does not exist","10080003":"Placement places are full","10080004":"Two password inconsistencies","10080005":"User does not exist","10080006":"Member password is incorrect","10080007":"Member Disabled","10080008":"Member Hang","10080009":"Member Not Active","20010001":"Canada","20010002":"United States","20010003":"Barbados","20010004":"Dominican Republic","20010005":"Jamaica","20010006":"Saint Kitts and Nevis","20010007":"Saint Vincent and the Grenadines","20010008":"Trinidad and Tobago","20010009":"Saint Lucia","20060001":"Normal","20060002":"Disable","20060003":"Not Shopping","20160001":"1*","20160002":"2*","20160003":"3*","20160004":"4*","20160005":"5*","20160006":"6*","20160007":"7*","20160008":"8*","20160009":"9*","20160010":"10*","20160011":"11*","20160012":"12*","20160013":"13*","20160014":"14*","20160015":"15*","20160016":"16*","20160017":"17*","20170001":"培育奖","20170002":"推荐奖","20170003":"管理奖","20170004":"合赢奖","20170005":"重复消费奖","20170006":"零售奖","20170007":"见点奖","20170008":"拓展奖","20170009":"直接奖","20170010":"间接奖","20170011":"领导奖","20170012":"事业伙伴奖","20170013":"荣衔直接奖","20170015":"荣衔间接奖","20170016":"钻石领导奖","20170017":"荣衔奖","20170018":"小车奖","20170019":"扣除","20170020":"差额","20170021":"升级时间","20170022":"直推人数","20170023":"当月个人业绩","20170024":"当月整网业绩","20170025":"网络基础业绩","20170026":"网络业绩","20170027":"小组业绩（含基础）","20170028":"小组业绩（不含基础）","20170029":"累计个人业绩","20170030":"累计整网业绩","20170031":"代数","20180001":"Registered Order","20180002":"Re-register Order","20180003":"Pre Purchase Order","20180004":"Common Order","20180005":"Customer Retail","20180006":"Flash Sale Order","20180007":"Repeated Consumption","20180008":"Integral Order","20190001":"Member","20190002":"Customer Service","20190003":"System","20190004":"Shop","100369901":"Member does not exist","100369902":"Email Verified","100369911":"The verification code does not exist","100369912":"Verification code does not match","100369913":"Please submit your personal information first","320030001":"English","320030002":"Western","320030003":"French","320030004":"Russian","320030005":"Chinese","320030006":"Pakistani","320070001":"Register Order","320070002":"Member Order","320070003":"Customer Order","320100001":"Approved","320100002":"Rejected","320100003":"Processing","320160001":"Cash","320160002":"Electronic Currency","320160003":"BankCard","320160004":"POS","320160005":"CreditCard","320160006":"PayPal","320160007":"Multiple Payments","320160008":"Email Payment","320160009":"Checkout Pay","320170001":"Federal Tax","320170002":"Provincial Tax","320170003":"HST","320170004":"Special Tax","320170005":"State Tax","320170006":"County Tax","320170007":"City Tax","320170008":"Transportation Tax","320190001":"Full Reduction","320190002":"Full Free","320190003":"Buy Special","320190004":"Buy And Send","320210001":"Hot Sale","320210002":"New Product","320210003":"Promotion Kit","320310001":"Transfer","320310002":"Deposit","320310003":"Charge","320310004":"Withdraw","320310005":"Withdraw failure","320310006":"Gift Card Issue","320310007":"Gift Card Return","320310008":"Gift Card Redeem","320310009":"Order","320310010":"Order Cancel","320310011":"Bonus","320310012":"Other","320310013":"Exchange","----------全局":"----------------（公用文字）","----------导航栏":"----------------","----------登录相关":"----------------","----------注册、购物相关":"----------------","----------商城产品相关":"----------------","----------购物车相关":"----------------","----------个人中心-账户管理":"----------------","----------个人中心-奖金管理":"----------------","----------个人中心-顾客管理":"----------------","----------个人中心-网络查询":"----------------","----------个人中心-订单管理":"----------------","----------个人中心-设置管理":"----------------","----------个人中心-个人网站":"----------------","----------数据库字典表":"----------------","---------会员职务------------":"","---------订单类别------------":"","----------接口错误码提示":"----------------","-----------------------------------------------":""}

/***/ }),

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_consts_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_storage_js__ = __webpack_require__(33);








// create an axios instance
var service = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: "https://us.world-food.com/mallApi", // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 15000 // request timeout
});

service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// service.defaults.headers.post['token'] = getStore(consts.KEY_USER_TOKEN);
// request interceptor
service.interceptors.request.use(function (config) {
  // 解决post参数问题
  if (config.method === 'post') {
    config.data = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(config.data);
  }

  var token = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_storage_js__["a" /* getStore */])(__WEBPACK_IMPORTED_MODULE_5__utils_consts_js__["a" /* default */].KEY_USER_TOKEN);
  var selectCountry = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_storage_js__["a" /* getStore */])(__WEBPACK_IMPORTED_MODULE_5__utils_consts_js__["a" /* default */].KEY_SELECT_COUNTRY);
  var langCode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_storage_js__["a" /* getStore */])(__WEBPACK_IMPORTED_MODULE_5__utils_consts_js__["a" /* default */].EVENT_LANG_CHANGE);
  config.headers.token = token && token.length > 0 ? token : '';
  config.headers.countryId = selectCountry && selectCountry.length > 0 ? JSON.parse(selectCountry).id : '';
  config.headers.langCode = langCode && langCode.length > 0 ? langCode : '';
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// response interceptor
service.interceptors.response.use(
/**
 * If you want to get http information such as headers or status
 * Please return  response => response
*/
function (response) {
  var res = response.data;
  // session过期重新登录
  if (res.result == 0 && res.code == 1003015) {
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('DELETE_USERINFO'); // 清除用户、登录状态数据
    __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
      path: '/login'
    });
    return;
  } else if (res.result == 0 && res.code == 1003006) {
    // 接口异常
    var curRoutePath = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.curRoutePath;
    if (curRoutePath.indexOf('/user/') > -1) {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({
        path: '/user/error'
      });
    }
  }
  return res;
}, function (error) {
  if (error.response) {}
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(71);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      actionMap: {
        '/user/proxyRegister/register': '8004109',
        //'/user/proxyRegister/shopping':'8004110',
        '/user/proxyRegister/orderConfirm': '8004111'
        //'/registerShopping':'8004096',
      }
    };
  },
  created: function created() {
    var _this = this;

    //在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener('beforeunload', function () {
      localStorage.setItem('messageStore', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this.$store.state));
    });

    //在页面加载时读取localStorage里的状态信息
    localStorage.getItem('messageStore') && this.$store.replaceState(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.$store.state, JSON.parse(localStorage.getItem('messageStore'))));
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])(['userInfo', 'curRoutePath'])),

  watch: {
    $route: function $route(to, from) {
      this.SET_ROUTE_PATH(to.path); //当前路由
      this.toPath = to.path;

      if (to.path === '/user/proxyRegister/register') {
        this.userInfo.proxyUser = {};
        this.RECORD_USERINFO(this.userInfo); //更新用户信息
      }
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['RECORD_USERINFO', 'GET_USERINFO', 'SET_ROUTE_PATH']))
});

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_D_workspace_mezura_us_online_trunk_static_mallWeb_theme_index_css__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_D_workspace_mezura_us_online_trunk_static_mallWeb_theme_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_D_workspace_mezura_us_online_trunk_static_mallWeb_theme_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store___ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_lazyload__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_infinite_scroll__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_cookies__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__node_modules_element_ui_lib_locale_lang_en__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__node_modules_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__node_modules_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vant__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vant_lib_index_css__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vant_lib_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vant_lib_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_i18n__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_storage__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_content_placeholders__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_quill_editor__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_consts_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__api_login_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_quill_dist_quill_core_css__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_quill_dist_quill_snow_css__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_quill_dist_quill_snow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_quill_dist_quill_bubble_css__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_quill_dist_quill_bubble_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_quill_dist_quill_bubble_css__);


// import '../element-variables.scss'







// element-ui组件
 // element-ui语言库
 // Vant-ui组件


 // sessionStorage对象

 // 富文本编辑






__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_quill_editor___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vant__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_content_placeholders__["default"]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib___default.a, { locale: __WEBPACK_IMPORTED_MODULE_9__node_modules_element_ui_lib_locale_lang_en___default.a });
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_cookies___default.a);

// 图片懒加载
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_lazyload___default.a, {
  loading: '/static/images/load.gif'
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

// 多语言
var i18n = new __WEBPACK_IMPORTED_MODULE_12_vue_i18n__["a" /* default */]({
  locale: 'en',
  messages: {
    ch: __webpack_require__(151),
    en: __webpack_require__(152)
  }
});

// 挂载Vue组件
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  i18n: i18n,
  store: __WEBPACK_IMPORTED_MODULE_5__store___["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App___default.a);
  }
});

window.eventBus = new __WEBPACK_IMPORTED_MODULE_2_vue__["default"](); // 注册全局事件对象

__WEBPACK_IMPORTED_MODULE_5__store___["a" /* default */].commit('SET_WEBSIZDE_USER', null); //


// 过滤白名单
var whiteList1 = ['/login', '/findPass', '/register', '/findPass', '/resetPassword', '/errorPage', '/linkNoActive', '/registerShopping', '/orderConfirm', '/orderFail', '/thirdPaying', '/categoryProduct', '/searchProduct', '/moreProduct', '/allProduct', '/allProduct', '/productDetail', '/purchasePolicy', '/privacyPolicy', '/registerPolicy', '/recommendProduct', '/aboutMe', '/usregister']; // 白名单列表

// 带*号虚拟白名单（特殊过滤）
var pattPath1 = /\/[1][0-9]{9}/;
var pattPath2 = /\/thirdPayResult.*/;
var pattPath3 = /\/findPassCheck.*/;
var pattPath4 = /\/verifyEmailCheck.*/;

__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].beforeEach(function (to, from, next) {
  document.body.scrollTop = 0;
  // firefox
  document.documentElement.scrollTop = 0;
  // safari

  // 缓存当前路由地址
  if (to.path !== '/user/error') {
    __WEBPACK_IMPORTED_MODULE_5__store___["a" /* default */].commit('SET_ROUTE_PATH', to.path);
  }

  // 根据路由地址判断
  if (whiteList1.indexOf(to.path) === -1 && !(pattPath1.test(to.path) || pattPath2.test(to.path) || pattPath3.test(to.path) || pattPath4.test(to.path))) {
    __WEBPACK_IMPORTED_MODULE_17__api_login_js__["a" /* default */].checkUser().then(function (response) {
      if (response.result !== 1) {
        // 未登录
        __WEBPACK_IMPORTED_MODULE_5__store___["a" /* default */].commit('DELETE_USERINFO'); // 清除用户、登录状态数据
        if (to.path === '/home') {
          next();
        } else {
          next('/login');
        }
      } else {
        var userInfo = response.resultMap.user;
        var stateUser = __WEBPACK_IMPORTED_MODULE_5__store___["a" /* default */].state.userInfo;

        // 更新缓存用户数据
        if (!stateUser || userInfo.userId != stateUser.userId) {
          __WEBPACK_IMPORTED_MODULE_5__store___["a" /* default */].commit('RECORD_USERINFO', userInfo);
        }
        if (to.path === '/login') {
          // 已登录
          next({
            path: '/'
          });
        }
        if (userInfo.status === 20060003 && userInfo.userType === 0) {
          // 未购物会员-进入购买注册单界面
          next({
            path: '/registerShopping'
          });
          __WEBPACK_IMPORTED_MODULE_5__store___["a" /* default */].commit('SET_ROUTE_PATH', '/registerShopping');
        } else {
          next();
        }
      }
    });
  } else {
    next();
  }
});

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INIT_BUYCART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_CART; });
/* unused harmony export GET_USERINFO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RECORD_USERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DELETE_USERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_ANIMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SHOW_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REDUCE_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EDIT_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_ROUTE_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_WEBSIZDE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_PROXY_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_COUNTRY_ID; });
var INIT_BUYCART = 'INIT_BUYCART';
var ADD_CART = 'ADD_CART';
var GET_USERINFO = 'GET_USERINFO';
var RECORD_USERINFO = 'RECORD_USERINFO';
var DELETE_USERINFO = 'DELETE_USERINFO';
var ADD_ANIMATION = 'ADD_ANIMATION';
var SHOW_CART = 'SHOW_CART';
var REDUCE_CART = 'REDUCE_CART';
var EDIT_CART = 'EDIT_CART';
var SET_ROUTE_PATH = 'SET_ROUTE_PATH';
var SET_WEBSIZDE_USER = 'SET_WEBSIZDE_USER';
var SET_PROXY_USER = 'SET_PROXY_USER';
var SET_COUNTRY_ID = 'SET_COUNTRY_ID';

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_consts_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_storage__ = __webpack_require__(33);


var _INIT_BUYCART$ADD_CAR;




/* harmony default export */ __webpack_exports__["a"] = (_INIT_BUYCART$ADD_CAR = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* INIT_BUYCART */], function (state) {
  var initCart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* getStore */])('buyCart');
  if (initCart) {
    state.cartList = JSON.parse(initCart);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* ADD_CART */], function (state, _ref) {
  var productId = _ref.productId,
      salePrice = _ref.salePrice,
      productName = _ref.productName,
      productImg = _ref.productImg,
      _ref$productNum = _ref.productNum,
      productNum = _ref$productNum === undefined ? 1 : _ref$productNum;

  var cart = state.cartList; // 购物车
  var falg = true;
  var goods = {
    productId: productId,
    salePrice: salePrice,
    productName: productName,
    productImg: productImg
  };
  if (cart.length) {
    // 有内容
    cart.forEach(function (item) {
      if (item.productId === productId) {
        if (item.productNum >= 0) {
          falg = false;
          item.productNum += productNum;
        }
      }
    });
  }
  if (!cart.length || falg) {
    goods.productNum = productNum;
    goods.checked = '1';
    cart.push(goods);
  }
  state.cartList = cart;
  // 存入localStorage
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('buyCart', cart);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* ADD_ANIMATION */], function (state, _ref2) {
  var moveShow = _ref2.moveShow,
      elLeft = _ref2.elLeft,
      elTop = _ref2.elTop,
      img = _ref2.img,
      cartPositionT = _ref2.cartPositionT,
      cartPositionL = _ref2.cartPositionL,
      tempCartPositionT = _ref2.tempCartPositionT,
      tempCartPositionL = _ref2.tempCartPositionL,
      receiveInCart = _ref2.receiveInCart;

  state.showMoveImg = moveShow;
  if (elLeft) {
    state.elLeft = elLeft;
    state.elTop = elTop;
  }
  state.moveImgUrl = img;
  state.receiveInCart = receiveInCart;

  // 会员购物车
  if (cartPositionT) {
    state.cartPositionT = cartPositionT;
    state.cartPositionL = cartPositionL;
  }

  // 临时购物车
  if (tempCartPositionT) {
    state.tempCartPositionT = tempCartPositionT;
    state.tempCartPositionL = tempCartPositionL;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* SHOW_CART */], function (state, _ref3) {
  var showCart = _ref3.showCart;

  // let timer = null
  state.showCart = showCart;
  // clearTimeout(timer)
  // if (showCart) {
  //   timer = setTimeout(() => {
  //     state.showCart = false
  //   }, 5000)
  // }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* REDUCE_CART */], function (state, _ref4) {
  var productId = _ref4.productId;

  var cart = state.cartList;
  cart.forEach(function (item, i) {
    if (item.productId === productId) {
      if (item.productNum > 1) {
        item.productNum--;
      } else {
        cart.splice(i, 1);
      }
    }
  });
  state.cartList = cart;
  // 存入localStorage
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('buyCart', state.cartList);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* EDIT_CART */], function (state, _ref5) {
  var productId = _ref5.productId,
      productNum = _ref5.productNum,
      checked = _ref5.checked;

  var cart = state.cartList;
  if (productNum) {
    cart.forEach(function (item, i) {
      if (item.productId === productId) {
        item.productNum = productNum;
        item.checked = checked;
      }
    });
  } else if (productId) {
    cart.forEach(function (item, i) {
      if (item.productId === productId) {
        cart.splice(i, 1);
      }
    });
  } else {
    cart.forEach(function (item) {
      item.checked = checked ? '1' : '0';
    });
  }
  state.cartList = cart;
  // 存入localStorage
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('buyCart', state.cartList);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* RECORD_USERINFO */], function (state, info) {
  state.userInfo = info;
  state.login = true;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])(__WEBPACK_IMPORTED_MODULE_2__utils_consts_js__["a" /* default */].KEY_USER_INFO, info);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* DELETE_USERINFO */], function (state) {
  state.userInfo = null;
  state.login = null;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["c" /* removeStore */])(__WEBPACK_IMPORTED_MODULE_2__utils_consts_js__["a" /* default */].KEY_USER_INFO);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, 'setUserInfo', function setUserInfo(state, info) {
  state.userInfo = info;
  state.login = true;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])(__WEBPACK_IMPORTED_MODULE_2__utils_consts_js__["a" /* default */].KEY_USER_INFO, info); // 缓存locaStroge
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* SET_ROUTE_PATH */], function (state, path) {
  state.curRoutePath = path;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* SET_WEBSIZDE_USER */], function (state, websideUser) {
  state.websideUser = websideUser;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* SET_PROXY_USER */], function (state, proxyUser) {
  state.proxyUser = proxyUser;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* SET_COUNTRY_ID */], function (state, countryId) {
  state.countryId = countryId;
}), _INIT_BUYCART$ADD_CAR);

/***/ }),

/***/ 223:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 224:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  KEY_IS_LOGIN: 'login',
  KEY_USER_INFO: 'userInfo',
  KEY_SELECT_COUNTRY: 'selectCountry',
  KEY_LANG_LIST: 'langList',
  KEY_USER_TOKEN: 'userToken',
  KEY_WEBUSER_ID: 'webUserId',
  EVENT_LANG_CHANGE: 'langChangeEvent',
  EVENT_COUNTRY_CHANGE: 'countryChangeEvent',
  EVENT_CART_NUM_CHANGE: 'cartNumChangeEvent'
});

/***/ }),

/***/ 324:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page",
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    staticClass: "content"
  }), _vm._v(" "), _c('el-backtop'), _vm._v(" "), (
    _vm.curRoutePath == '/user/proxyRegister/register' ||
    _vm.curRoutePath == '/user/proxyRegister/orderConfirm' ||
    _vm.curRoutePath == '/user/proxyRegister/paySuccess'
  ) ? _c('div', {
    staticClass: "float-tip"
  }, [_c('el-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 4
    }
  }, [_c('img', {
    staticStyle: {
      "width": "30px",
      "height": "30px",
      "margin-top": "3px"
    },
    attrs: {
      "src": "/static/img/mini-logo.png"
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 20,
      "align": "middle"
    }
  }, [(_vm.curRoutePath == '/user/proxyRegister/register') ? _c('p', {
    staticClass: "font-size-16"
  }, [_c('em', [_vm._v(_vm._s(_vm.$t(_vm.actionMap[_vm.curRoutePath])))])]) : _vm._e(), _vm._v(" "), (_vm.curRoutePath == '/user/proxyRegister/shopping') ? _c('p', {
    staticClass: "font-size-16"
  }, [_c('em', [_vm._v(_vm._s(_vm.$t(_vm.actionMap[_vm.curRoutePath])))])]) : _vm._e(), _vm._v(" "), (_vm.curRoutePath == '/user/proxyRegister/orderConfirm') ? _c('p', {
    staticClass: "font-size-16"
  }, [_c('em', [_vm._v(_vm._s(_vm.$t(_vm.actionMap[_vm.curRoutePath])))])]) : _vm._e(), _vm._v(" "), (_vm.curRoutePath == '/user/proxyRegister/shopping' || _vm.curRoutePath == '/user/proxyRegister/orderConfirm' || _vm.curRoutePath == '/user/proxyRegister/paySuccess') ? _c('p', {
    staticClass: "font-size-14"
  }, [_vm._v("\n          Id:" + _vm._s(_vm.userInfo.proxyUser.userId) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.curRoutePath == '/registerShopping') ? _c('p', {
    staticClass: "font-size-16"
  }, [_c('em', [_vm._v(_vm._s(_vm.$t(_vm.actionMap[_vm.curRoutePath])))])]) : _vm._e(), _vm._v(" "), (_vm.curRoutePath == '/registerShopping') ? _c('p', {
    staticClass: "font-size-16"
  }, [_vm._v("Id:" + _vm._s(_vm.userInfo.userId))]) : _vm._e()])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/**
 * 存储localStorage
 */
var setStore = function setStore(name, content) {
  if (!name) return;
  if (typeof content !== 'string') {
    content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
var getStore = function getStore(name) {
  if (!name) return;
  return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
var removeStore = function removeStore(name) {
  if (!name) return;
  window.localStorage.removeItem(name);
};

/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(325);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '*',
    redirect: '/home'
  }, {
    path: '/:id(\\d+)',
    name: '个人网站访问入口',
    component: function component() {
      return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 399));
    }
  }, {
    path: '/wwwForward',
    name: '官网站访问入口',
    component: function component() {
      return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 401));
    }
  }, {
    path: '/proxylogin*',
    name: '分公司代登录入口',
    component: function component() {
      return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 390));
    }
  }, {
    path: '/thirdPayResult*',
    name: '第三方支付完成跳转地址（支付成功、失败、取消支付）',
    component: function component() {
      return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 397));
    }
  }, {
    path: '/findPassCheck*',
    name: '找回密码，验证链接是否有效',
    component: function component() {
      return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 337));
    }
  }, {
    path: '/resetPassword',
    name: '找回密码-设置密码',
    component: function component() {
      return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 346));
    }
  }, {
    path: '/verifyEmailCheck*',
    name: '邮箱验证',
    component: function component() {
      return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 400));
    }
  }, {
    path: '/errorPage',
    name: '404页面',
    component: function component() {
      return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 333));
    }
  }, {
    path: '/linkNoActive',
    name: '未激活错误提示',
    component: function component() {
      return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 341));
    }
  }, {
    path: '/',
    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 340));
    },
    name: '商城',
    redirect: '/home', // 重定向产品首页
    children: [{
      path: 'home',
      name: '产品首页',
      component: function component() {
        return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 338));
      }
    }, {
      path: 'categoryProduct',
      name: '分类产品',
      component: function component() {
        return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 383));
      }
    }, {
      path: 'searchProduct',
      name: '搜索产品',
      component: function component() {
        return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 389));
      }
    }, {
      path: 'allProduct',
      name: '全部产品',
      component: function component() {
        return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 382));
      }
    }, {
      path: 'promoPorduct',
      name: '促销产品',
      component: function component() {
        return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 387));
      }
    }, {
      path: 'moreProduct',
      name: '更多产品',
      component: function component() {
        return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 384));
      }
    }, {
      path: 'recommendProduct',
      name: '推荐产品',
      component: function component() {
        return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 388));
      }
    }, {
      path: 'aboutMe',
      name: '关于我的',
      component: function component() {
        return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 379));
      }
    }, {
      path: 'productDetail',
      name: '产品详情',
      component: function component() {
        return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 386));
      }
    }, {
      path: 'packageDetail',
      name: '产品包详情',
      component: function component() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 385));
      }
    }]
  }, {
    path: '/promotion',
    name: '商城促销',
    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 339));
    }
  }, {
    path: '/user',
    component: function component() {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 398));
    },
    name: '我的',
    redirect: '/user/center', // 重定个人中心主界面
    children: [{
      path: 'center',
      name: '个人中心',
      component: function component() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 358));
      }
    }, {
      path: 'index',
      name: '菜单界面',
      component: function component() {
        return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 362));
      },
      redirect: '/user/order/orderList', // 重定个人中心主界面
      children: [
      // 订单管理
      {
        path: '/user/order/orderList',
        name: '订单列表',
        component: function component() {
          return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 367));
        }
      }, {
        path: '/user/order/orderDetail',
        name: '订单详情',
        component: function component() {
          return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 366));
        }
      }, {
        path: '/user/order/wishList',
        name: '收藏列表',
        component: function component() {
          return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 368));
        }
      },

      // 账户设置
      {
        path: '/user/setting/personalInfo',
        name: '个人信息',
        component: function component() {
          return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 376));
        }
      }, {
        path: '/user/setting/address',
        name: '邮寄地址',
        component: function component() {
          return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 374));
        }
      }, {
        path: '/user/setting/security',
        name: '安全设置',
        component: function component() {
          return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 377));
        }
      }, {
        path: '/user/setting/modifyPassword',
        name: '修改密码',
        component: function component() {
          return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 375));
        }
      }, {
        path: '/user/setting/verifyEmail',
        name: '验证邮箱',
        component: function component() {
          return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 378));
        }
      },

      // 代客注册
      {
        path: '/user/proxyRegister/proxyUserList',
        name: '代注册会员列表',
        component: function component() {
          return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 373));
        }
      }, {
        path: '/user/proxyRegister/register',
        name: '代客注册',
        component: function component() {
          return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 331));
        }
      }, {
        path: '/user/proxyRegister/shopping',
        name: '代客购物',
        component: function component() {
          return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 332));
        }
      }, {
        path: '/user/proxyRegister/orderConfirm',
        name: '订单确认',
        component: function component() {
          return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 330));
        }
      }, {
        path: '/user/proxyRegister/paySuccess',
        name: '订单支付成功',
        component: function component() {
          return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 372));
        }
      }, {
        path: '/user/proxyRegister/payFail',
        name: '订单支付失败',
        component: function component() {
          return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 371));
        }
      }, {
        path: '/user/proxyRegister/payCancel',
        name: '订单支付取消',
        component: function component() {
          return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 370));
        }
      }, {
        path: '/user/proxyRegister/orderFail',
        name: '下单失败',
        component: function component() {
          return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 369));
        }
      },
      // 电子币管理
      {
        path: '/user/account/myAccount',
        name: '我的账户',
        component: function component() {
          return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 354));
        }
      }, {
        path: '/user/account/financeList',
        name: '电子币转账记录',
        component: function component() {
          return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 353));
        }
      }, {
        path: '/user/account/elTransfer',
        name: '电子币转账',
        component: function component() {
          return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 350));
        }
      }, {
        path: '/user/account/elWithdraw',
        name: '电子币提现',
        component: function component() {
          return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 351));
        }
      }, {
        path: '/user/account/elWithdrawRecord',
        name: '提现记录',
        component: function component() {
          return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 352));
        }
      }, {
        path: '/user/account/redPack',
        name: '红包管理',
        component: function component() {
          return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 355));
        }
      },

      // 奖金
      {
        path: '/user/bonus/bonusList',
        name: '奖金查询',
        component: function component() {
          return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 357));
        }
      }, {
        path: '/user/bonus/bonusDetail',
        name: '奖金明细',
        component: function component() {
          return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 356));
        }
      },

      // 顾客管理
      {
        path: '/user/customer/customerList',
        name: '顾客列表',
        component: function component() {
          return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 360));
        }
      }, {
        path: '/user/customer/customerDetail',
        name: '顾客详情',
        component: function component() {
          return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 359));
        }
      }, {
        path: '/user/customer/orderList',
        name: '订单列表',
        component: function component() {
          return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 361));
        }
      },

      // 网站
      {
        path: '/user/website/websiteConfig',
        name: '个人网站',
        component: function component() {
          return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 381));
        }
      }, {
        path: '/user/website/chooseProduct',
        name: '选择产品',
        component: function component() {
          return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 380));
        }
      },

      // 网络查询
      {
        path: '/user/network/tabelView',
        name: '网络查询（tabelView）',
        component: function component() {
          return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 364));
        }
      }, {
        path: '/user/network/treeView',
        name: '网络查询',
        component: function component() {
          return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 365));
        }
      }, {
        path: '/user/network/orgView',
        name: '网络查询',
        component: function component() {
          return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 363));
        }
      }, {
        path: '/user/error',
        name: '404错误',
        component: function component() {
          return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 349));
        }
      }]
    }]
  }, {
    path: '/login',
    name: '登录',
    component: function component() {
      return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 343));
    }
  }, {
    path: '/findPass',
    name: '找回密码',
    component: function component() {
      return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 342));
    }
  }, {
    path: '/register',
    name: '注册',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 345));
    }
  }, {
    path: '/usregister',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 348));
    },
    name: '美国注册'
  }, {
    path: '/registerShopping',
    name: '注册购物',
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 347));
    }
  }, {
    path: '/orderConfirm',
    name: '注册单确认',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 344));
    }
  }, {
    path: '/purchasePolicy',
    name: '购买协议',
    component: function component() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 335));
    }
  }, {
    path: '/privacyPolicy',
    name: '隐私协议',
    component: function component() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 334));
    }
  }, {
    path: '/registerPolicy*',
    name: '注册协议',
    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 336));
    }
  }, {
    path: '/cart',
    name: '购物车',
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 391));
    }
  }, {
    path: '/cartOrderConfirm',
    name: '购物车订单确认',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 392));
    }
  }, {
    path: '/paySuccess',
    name: '下单成功',
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 396));
    }
  }, {
    path: '/payFail',
    name: '订单支付失败',
    component: function component() {
      return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 395));
    }
  }, {
    path: '/payCancel',
    name: '订货取消支付',
    component: function component() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 394));
    }
  }, {
    path: '/orderFail',
    name: '下单失败',
    component: function component() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 393));
    }
  }]
}));

/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action__ = __webpack_require__(178);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

var state = {

  login: false, // 是否登录
  userInfo: null, // 用户信息

  cartList: [], // 加入购物车列表
  showMoveImg: false, // 显示飞入图片
  moveImgUrl: null,

  elLeft: 0,
  elTop: 0,

  cartPositionT: 0, // 购物车位置
  cartPositionL: 0,

  tempCartPositionT: 0, // 临时购物车位置
  tempCartPositionL: 0,

  receiveInCart: false, // 是否进入购物车
  showCart: false, // 是否显示购物车

  curRoutePath: null, // 当前路由

  websideUser: null // 个人网站链接进入
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  state: state,
  action: __WEBPACK_IMPORTED_MODULE_3__action__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
}));

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_request__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_consts_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_storage_js__ = __webpack_require__(33);



/* harmony default export */ __webpack_exports__["a"] = ({

  // 登录
  login: function login(userId, password) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
      url: '/mall/user/login',
      method: 'post',
      params: {
        'userId': userId,
        'password': password
      }
    });
  },

  // 登出系统
  logout: function logout() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
      url: '/mall/user/logOut',
      method: 'post',
      params: {}
    });
  },

  // 邮箱点击进入找回密码校验链接是否有效
  checkfindPassCode: function checkfindPassCode(id, code) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
      url: '/mall/user/checkPassCode',
      method: 'post',
      params: {
        id: id,
        code: code
      }
    });
  },

  // 申请找回密码
  findPassWord: function findPassWord(userId, email) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
      url: '/mall/user/sendPassCode',
      method: 'post',
      params: {
        userId: userId,
        email: email
      }
    });
  },

  // 找回密码-设置密码(未登录情况下)
  resetPassWord: function resetPassWord(id, password) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
      url: '/mall/user/findPassWord',
      method: 'post',
      params: {
        id: id,
        pass: password
      }
    });
  },

  // 邮箱点击进入邮箱验证链接是否有效
  checkVerifyEmailCode: function checkVerifyEmailCode(id, code) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
      url: '/mall/user/checkEmailCode',
      method: 'post',
      params: {
        id: id,
        code: code
      }
    });
  },

  // 检查用户是否存在
  checkUser: function checkUser() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
      url: '/mall/user/getSessionStatus',
      method: 'post',
      params: {}
    });
  },

  // 分公司管理员代替登录
  branchProxyLogin: function branchProxyLogin(sign, userId, token) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
      url: '/mall/branch/login',
      method: 'post',
      params: {
        sign: sign,
        userId: userId,
        token: token
      }
    });
  }
});

/***/ })

},[177]);


// WEBPACK FOOTER //
// static/js/app.7840db55b557884fa90a.js